<template>
  <DetailsModal
      ref="cercaEmpleat"
      title="Cerca d'empleats" 
      @close="empleatTrobat"
      :user="user" 
      :access-token="accessToken"
  /> 
      <!--z-index: 3000;-->
  <nav class="navbar navbar-dark bg-dark sticky-top px-1" style="position: relative;height: 80px;">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">Claror Factor Humà</a>

      <button v-if="!user && !error" class="btn fw-bold text-info btn-outline-light me-1 position-relative" 
              @click="doLogin"
              style="font-size: 22px">
        login
        <i class="bi bi-person-fill bi-lg fw-bold text-info"></i>
      </button>
      <div v-else class="dropdown">
        <button 
          id="dropdownMenuButton1" 
          class="btn btn-outline-info dropdown-toggle btn-outline-light" 
          type="button" 
          data-bs-toggle="dropdown" 
          aria-expanded="false">
          {{ familyName }}
        </button>
        <ul class="dropdown-menu p-1 dropdown-menu-end" aria-labelledby="dropdownMenuButton1" style="margin:0">
          <li><a class="dropdown-item" href="#" @click="this.$refs.cercaEmpleat.show()"><i class="fas fa-search fa-fw" /> Cerca empleat</a></li>
          <li><hr class="dropdown-divider"></li>
          <li><a class="dropdown-item" href="#" @click="shallowLogout"><i class="fas fa-sign-out-alt fa-fw" /> Tancar sessió</a></li>
          <li><a class="dropdown-item" href="#" @click="fullLogout"><i class="fas fa-door-open fa-fw" /> Tancar sessió Microsoft</a></li>
        </ul>
      </div>
    </div>
  </nav>
  <div class="container-fluid">
    <div v-if="error" class="alert alert-error" role="alert">
        {{ error }}
    </div>
    <Login v-if="!user && !error" ref="login365" @loginComplete="updateUser"/>
    <div v-if="user && !error" class="row row-cols-1 row-cols-md-3">
        <div class="col">
          <form>
            <fieldset disabled>
              <legend>Dades Microsoft</legend>
              <div class="mb-1">
                <label for="disabledTextInput" class="form-label">nom</label>
                <input type="text" class="form-control" placeholder="nom empleat" :value="empleatSeleccionat.nom">
              </div>
              <div class="mb-1">
                <label for="disabledSelect" class="form-label">email</label>
                <input type="text" class="form-control" placeholder="email principal" :value="empleatSeleccionat.email">
              </div>
            </fieldset>
          </form>
        </div>
        <div class="col">
          <form>
            <fieldset disabled>
              <legend :class="dadesSageEmpleatTrobades ? 'existeixenDadesSage' : 'noexisteixenDadesSage'">Dades Sage</legend>
              <div class="mb-1">
                <label for="disabledTextInput" class="form-label">nom</label>
                <input type="text" class="form-control" placeholder="nom empleat" :value="empleatSageSeleccionat.nom">
              </div>
              <div class="row">
                <div class="col col-6">
                  <div class="mb-1">
                    <label for="disabledSelect" class="form-label">dni</label>
                  <input type="text" class="form-control" placeholder="dni" :value="empleatSageSeleccionat.dni">
                </div>
                </div>
                <div class="col col-6">
                  <div class="mb-1">
                    <label for="disabledSelect" class="form-label">data naix.</label>
                    <input type="text" class="form-control" placeholder="data naixement" :value="empleatSageSeleccionat.naix">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col col-12">
                  <label for="disabledSelect" class="form-label">empleat vinculat a idSage</label>
                  <input type="text" class="form-control" placeholder="cap empleat vinculat" :value="empleatQHsSeleccionat.nom">
                </div>
              </div>
              
            </fieldset>
          </form>
        </div>
        <div class="col">
          <form>
            <fieldset>
              <legend>Tags</legend>
              <div class="mb-1">
                <label class="form-label">nou tag</label>
                <input ref="noutag" type="text" class="form-control" placeholder="llegeix tag"  v-model="dataTag">
              </div>
              <div class="mb-1">
                <label class="form-label invisible">add</label>
                <button type="button" class="form-control btn btn-primary" v-if="botoAfegirTagHabilitat" @click="afegirTag">Afegir tag</button>
                <button type="button" class="form-control btn btn-secundary" v-else disabled>Afegir tag</button>
              </div>
              
            </fieldset>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">tag</th>
                  <th scope="col">data alta</th>
                  <th scope="col">data baixa</th>
                  <th scope="col">baixa</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tg,index) in tags" :key="index">
                  <td>{{tg.tag}}</td>
                  <td>{{tg.data_alta}}</td>
                  <td>{{tg.data_baixa}}</td>
                  <td v-if="!tg.data_baixa">
                    <button type="button" class="btn btn-xs trash" @click="baixaTag(tg.tag)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div>
          <form>
            <fieldset>
              <legend>Computs i marcatges</legend>
            </fieldset>
            <div class="taulacomputs" v-html="htmlGeneraTaula"></div>
          </form>          
        </div>
      </div>
  </div>
</template>









<script>
    import auth from '@/services/auth'
    import DetailsModal from '@/components/assignaTags/DetailsModal.vue'
    import {obtenirEmpleatPerEmail,inserirTagEmpleat,obtenirTagsEmpleat,obtenirVersioGW,obtenirVersioQH,
            obtenirEmpleatQHs,baixaTagEmpleat,obtenirComputiMarcatgesperMes} from '@/apis/apiQHs'
    import graph from '@/services/graph'
    import Login from '@/components/MsLogin'
    export default {
        name: 'AssignaTagsView',
        components: { Login, DetailsModal, },
        data: function() {
          return {
            //MSAL
            // User account object synced with MSAL getAccount()
            user: {},
            //Access token fetched via MSAL for calling Graph API
            accessToken: '',
            // Details fetched from Graph API, user object and photo
            graphDetails: null,
            graphPhoto: null,
            // Visibility toggles for the three details modal popups
            showUserDetails: false,
            showGraphDetails: false,
            showTokenDetails: false,
            // Any errors
            error: '',
            //
            empleat:null,
            empleatSage:null,
            dadesSageEmpleatTrobades:true,
            empleatQHs: null,
            dataTag:'',
            tags:{},
            computs:[],

          }
        },
        computed: {
          htmlGeneraTaula() {
            if (this.computs.length == 0) {
              return ''
            }
            let dia_s=(this.computs[0]).data
            let repes = []
            let numrepe = 0
            this.computs.forEach((comput,index) => {
              if (dia_s==comput.data) {
                numrepe +=1
              } else {
                var myArray = new Object();
                myArray['data'] = dia_s
                myArray['num'] = numrepe
                repes.push(myArray)
                numrepe=1
                dia_s=comput.data
              }
              if (index == this.computs.length-1) {
                var myArray = new Object();
                myArray['data'] = dia_s
                myArray['num'] = numrepe
                repes.push(myArray)
              }
            })
            // console.log(repes)
            let html = `<table class="table"> 
                          <thead>
                            <tr>
                              <th scope="col">data</th>
                              <th scope="col"></th>
                              <th scope="col">entrada</th>
                              <th scope="col">sortida</th>
                            </tr>
                          </thead>
                          <tbody>`
            // console.log((repes.find(o => o.data == '2023-04-03')).num)
            let dia = ''
            let nhoraris = 0
            /*this.computs.forEach((comput) => {
                html += `<tr class="odd ${comput.wdata==7 ? 'diumenge' : ''}">`
                if (dia != comput.data) {
                  html += ` <td rowspan="${(repes.find(o => o.data == comput.data)).num}">${this.diacurtdelasetmana(+comput.wdata)+'-'+comput.ndata}</td>`
                  nhoraris=1
                } else {
                  nhoraris +=1
                }  
                html += ` <td class="${this.computcellcolorhoraris(comput.hora_ini)}">${comput.hora_ini=='' ? '' : nhoraris}</td>
                          <td class="${this.computcellcolor(comput.hora_ini)}">${comput.hora_ini}</td>
                          <td class="${this.computcellcolor(comput.hora_fi)}">${comput.hora_fi}</td>
                        </tr>`;

                dia = comput.data
            });
                html += ` </tbody>
                        </table>`
            return html*/
          },








          botoAfegirTagHabilitat() {
            if (!this.empleatSage) {return false}
            if (!this.empleatQHs) {return false}
            return (this.empleatSage.nom != '' && this.dataTag.length==8)
          },
          empleatSeleccionat() {
            if (this.empleat) {
              return {'nom':this.empleat.displayName,'email':this.empleat.mail, 'id':this.empleat.id}
            } else {
              return {'nom':'','email':'','id':''}
            }
          },
          empleatSageSeleccionat() {
            if (this.empleatSage) {
              this.dadesSageEmpleatTrobades=true
              return {'nom':this.empleatSage.NombreEmpleado + ' ' + this.empleatSage.PrimerApellidoEmpleado + ' ' + this.empleatSage.SegundoApellidoEmpleado + ' ',
                      'dni':this.empleatSage.DNI,
                      'codiSage':this.empleatSage.CodigoEmpleado,
                      'naix':this.empleatSage.FechaNacimiento,
                    }
            } else {
              this.dadesSageEmpleatTrobades=false
              return {'nom':'','dni':'','codiSage':'','naix':''}
            }
          },
          empleatQHsSeleccionat() {
            if (this.empleatQHs) {
              return {'nom':this.empleatQHs.nom}
            } else {
              return {'nom':''}
            }
          },

          familyName() {
            if (this.user) {
              return (this.user.name).split(" ")[0]
            } else {
              return ''
            }
          },
        },
        watch: {
          // If user changes, make calls to Graph API
          user: async function() {
            this.fetchGraphDetails()
          }
        },

        async created() {
          // Basic setup of MSAL helper with client id, or give up
          if (process.env.VUE_APP_CLIENT_ID) {
            await auth.configure(process.env.VUE_APP_CLIENT_ID, false).then(this.user = auth.user())
            // Restore any cached or saved local user
            //this.user = auth.user()
            //console.log(this.user)
            //console.log(`configured ${auth.isConfigured()}`)
            this.dadesSageEmpleatTrobades=true
          } else {
            this.error = 'VUE_APP_CLIENT_ID is not set, the app will not function! 😥'
          }
        },
        methods: {
          //MSAL
          doLogin() {
            this.$refs.login365.doLogin()
          },
          updateUser() {
            // Update user from MSAL
            this.user = auth.user()
          },
          // Remove locally held user details, is same as logout
          shallowLogout() {
            this.user = null
            this.graphDetails = null
            this.userDetails = null
            this.graphPhoto = null
            auth.clearLocal()
          },
          // Full logout local & server side
          fullLogout() {
            auth.logout()
          },
          // Get an access token and call graphGetSelf & graphGetPhoto
          async fetchGraphDetails() {
            if (!this.user) {
              return
            }
            try {
              this.graphDetails = await graph.getSelf()
              //this.graphPhoto = await graph.getPhoto()
              this.accessToken = graph.getAccessToken()
            } catch (err) {
              this.error = err
            }
          },



          //--------------------------------------------------------------
          resetDades() {
            this.empleat=null
            this.empleatSage= null
            this.empleatQHs = null
            this.tags = {}
            this.computs=[]
            this.dadesSageEmpleatTrobades=true
          },
          getEmpleatSage: async function(email) {
              //data from endpoint
              this.dadesSageEmpleatTrobades=true
              return await obtenirEmpleatPerEmail(email)
          },
          async empleatTrobat(empleat){
            //console.log(empleat.displayName)
            this.resetDades()
            if (empleat) 
              {
                this.empleat=empleat
                //console.log(empleat)
                //console.log(await obtenirVersioGW())
                //console.log(await obtenirVersioQH())
                this.empleatSage= await this.getEmpleatSage(empleat.mail)
                if (this.empleatSage) {
                  const resQUs = await obtenirEmpleatQHs(this.empleatSage.CodigoEmpleado)
                  if (resQUs) {
                    this.empleatQHs = resQUs
                  }
                  this.tags = await obtenirTagsEmpleat(this.empleatSage.CodigoEmpleado)
                  this.$refs.noutag.focus();
                }
                let date = new Date();
                let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                /*console.log(moment(firstDay).format('YYYYMMdd'))
                if (this.empleatQHs) {
                  this.computs = await obtenirComputiMarcatgesperMes(this.empleatQHs.num,firstDay)
                }*/
                //console.log(this.computs)
              } else {
                this.resetDades()
              }
            this.showUserDetails = false
          },
          async afegirTag() {
            try {
              await inserirTagEmpleat(this.empleatSage.CodigoEmpleado,this.dataTag)
              this.tags = await obtenirTagsEmpleat(this.empleatSage.CodigoEmpleado)
            }  catch (err) {
              //PRIMARY KEY constraint
              const error = err.message.response.data.error
              if (error.includes('PRIMARY KEY constraint')) {
                this.error = 'El tag ja existeix a la base de dades'
              
              } else {  
                this.error = err.message.response.data.error
              }
            }
            setTimeout(() => {
              this.error =''
              this.$refs.noutag.focus();
            }, 4000)
            this.dataTag=''
            this.$refs.noutag.focus();
          },
          async baixaTag(tag) {
            try {
              await baixaTagEmpleat(this.empleatSage.CodigoEmpleado,tag)
                let found = this.tags.filter(function(item) { return item.tag === tag; })
                found[0].data_baixa = new Date().toJSON().slice(0,10).split('-').reverse().join('/')
            }  catch (err) {
              //
              console.log(err)
            }
          },
          diacurtdelasetmana(numeroDia) 
            {
              switch(numeroDia) {
                case 1:
                  return "dl";
                case 2:
                  return "dm";
                case 3:
                  return "dc";
                case 4:
                  return "dj";
                case 5:
                  return "dv";
                case 6:
                  return "ds";
                case 7:
                  return "dg";
                }
            }, 

            //classes colors cel·les
            computcellcolor(text) {
              let $className="odd"
              if (text=='') {
                $className="nopaint"
              }
              return $className
            },
            computcellcolorhoraris(text) {
              let $className="oddr"
              if (text=='') {
                $className="nopaint"
              }
              return $className
            },
        }

    }
</script>

<style scoped>
    /* html {
      font-size: 20px;
    } */
    /* Style buttons */
    .existeixenDadesSage {
      color: black;
    }
    .noexisteixenDadesSage {
      color: red;
    }
    .btn.trash {
      background-color: red; /* Blue background */
      border: none; /* Remove borders */
      color: white; /* White text */
      width: 30px;
      height: 30px;
      padding: 6px 0px;
      border-radius: 15px;
      text-align: center;
      font-size: 12px; /* Set a font size */
      cursor: pointer; /* Mouse pointer on hover */
    }

    /* Darker background on mouse-over */
    .btn.trash:hover {
      background-color: DarkRed;
    }
    
    /* .taulacomputs:deep(table) {
       
    } */
    .taulacomputs:deep(td,th) {
        border: 1px solid white;
        border-collapse: collapse;
        text-align: center;
        vertical-align : middle
    }
    .taulacomputs:deep(.nopaint) {
        background: white;
    }
    .taulacomputs:deep(.odd){
        background: #B6E1EE;
        border-radius: 10px;
        /* padding-bottom: 3px; */
      }
      .taulacomputs:deep(.oddr){
        background: #82d2ea;
        border-radius: 100px;
        /* padding-bottom: 3px; */
    }
    .taulacomputs:deep(.even) {
        background: #d6d6d6;
    }
    .taulacomputs:deep(.diumenge) {
        background: #878787;
    }

</style>
  

